export const AT_DRIVES_LOADING_SET = 'OPEN_BOARDS_DIALOG_DRIVES_LOADING_SET';
export const AT_DRIVES_SET =         'OPEN_BOARDS_DIALOG_DRIVES_SET';
